function initProductCardVideos() {
  document.querySelectorAll(".product-card").forEach(card => {
    console.log('a');
    // const video = card.querySelector(".product-card__video video");
    const video = card.querySelector(".kz-product-video");

    if (video) {
      video.pause();

      if (!card.dataset.videoInit) {
        card.addEventListener("mouseenter", () => {
          video.play().catch(() => {});
        });

        card.addEventListener("mouseleave", () => {
          video.pause();
          video.currentTime = 0;
        });

        card.dataset.videoInit = "true";
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(initProductCardVideos, 100);
  console.log('j');

  document.querySelectorAll(".featured-collections button.tab__item")
    .forEach(button => {
      button.addEventListener("click", () => {
        setTimeout(initProductCardVideos, 100);
      });
    });
});